import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import 'vant/lib/index.css';
import 'vant/es/toast/style';
import '@vant/touch-emulator';
import './styles/index.scss';
import 'lib-flexible';
import { bindFlexibleRemGuard, ensureFlexibleRem } from './utils/flexible-rem';
import {
  maybeEnableVConsoleFromQuery,
  maybeEnableVConsoleForShareLanding
} from './utils/vconsole';

/** 公众号/微信内调试：?vconsole=1 / ?debug=1 */
maybeEnableVConsoleFromQuery();
/** 计划书分享落地页默认开 vConsole（proposal / market proposal / review / share=1） */
maybeEnableVConsoleForShareLanding();

bindFlexibleRemGuard();

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.mount('#app');
ensureFlexibleRem();